import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { injectIntl } from 'react-intl';

import GameContainer from './GameContainer.js';

import CannonballCanvas from '../games/CannonballCanvas.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import { getSoundPropsById, i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	return null;
};

const GoalsCounter = forwardRef(({ min_goals, ...props }, ref) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const num_initial_goals = 0;
	const [ num_goals, setNumGoals ] = useState(num_initial_goals);

	useImperativeHandle(ref, () => ({
		updateNumGoals(num) {
			setNumGoals(num);
		},

		reset() {
			setNumGoals(num_initial_goals);
		},
	}), []);

	return (
		<div class="gui_total_points header_block">
			<strong class="label">{i18n("Goals")}</strong>

			<strong>{num_goals}/{min_goals}</strong>
		</div>
	)
});

const CannonballClient = ({ stage, ...props }) => {
	const refs = useRef({});

	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage.Stage, 'bg_image')) {
			images.push({
				id:'bg_image',
				name:stage.Stage.bg_image,
				url:stage.Stage.full_bg_image,
				fit:'cover',
			})
		}

		return images;
	};

	const sound_fx = {
		kick:new Howl({ ...getSoundPropsById('football-kick') }),
		goal:new Howl({ ...getSoundPropsById('football-goal') }),
		reject:new Howl({ ...getSoundPropsById('football-kick') }),
		reject_player:new Howl({ ...getSoundPropsById('football-uy') }),
		success:new Howl({ ...getSoundPropsById('applause') }),
		fail:new Howl({ ...getSoundPropsById('fail') }),
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			stage.Stage.bg_image,
		],
	});

	const onReset = () => {
		refs.current['goals_counter'].reset();
	};

	const final_stage = clientFinalPage(stage, props.actual_state);
	final_stage.Stage.cannonball_mode = 'basket';

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			onReset={onReset}
			custom_block={<GoalsCounter
				ref={(node) => { refs.current['goals_counter'] = node; }}
				min_goals={parseInt(stage.Stage?.cannonball_num_hits ?? '1')}
				intl={props.intl}
			/>}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			game_type="basketball"
			display_audio_controls={true}
			auto_start_timer={false}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
			force_game_to_square={false}
			sound_fx={sound_fx}
		>
			<CannonballCanvas
				indexed_images={state.images}
				updateActualGoals={(num) => refs.current['goals_counter'].updateNumGoals(num)}
			/>
		</GameContainer>
	)
};

export default injectIntl(CannonballClient);